module.exports = __webpack_public_path__ + "static/media/image3.50086b58.jpeg";